// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1wPUV","footer":"ModalInfo_footer__1n_Qp"};